module.exports = __webpack_public_path__ + "img/6d8d4be1f35c140bf6e80547e5d31785.png";